import React from 'react';
import type { AttributeTypeRow } from '../attributesMeta';
import { TypesTableView } from './TypesTableView';
import { useTypesTable } from './useTypesTable';

type TypesTableProps = {
    data: AttributeTypeRow[];
    onDeleteType: (id: string) => void;
    onEditType: (id: string) => void;
    onManageValues: (id: string) => void;
};

/**
 * Container for the attribute-types table: instantiates the sort + pagination
 * hook and hands its output (plus the row-action callbacks) to the render-only
 * View.
 */
export const TypesTable: React.FC<TypesTableProps> = ({
    data,
    onDeleteType,
    onEditType,
    onManageValues,
}) => {
    const table = useTypesTable(data);

    return (
        <TypesTableView
            onDeleteType={onDeleteType}
            onEditType={onEditType}
            onManageValues={onManageValues}
            table={table}
        />
    );
};
